<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>


        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <!--<a mat-button href="" target="_blank">Documentation</a>-->
          
            <!--<a mat-button href="" target="_blank">Changelog</a>-->
        </div>
       
    </div>

</mat-toolbar>